import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../stores/auth-store";
import { FullPageSpinner } from "../components/FullPageSpinner";

/** Login/register/forgot-password. An authenticated user landing here goes to the dashboard
 * instead of being shown a login form they don't need. */
export function PublicRoute() {
  const status = useAuthStore((s) => s.status);

  if (status === "loading") return <FullPageSpinner />;
  if (status === "authenticated") return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
